export default "__VITE_PUBLIC_ASSET__ce15d76a__"